import React from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane } from 'react-icons/fa';

const ContactForm = () => {
    return (
        <motion.div
            className="contact-form-container"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
        >
            <form
                action="https://formsubmit.co/deirmencimehmet@gmail.com"
                method="POST"
                className="contact-form"
            >
                {/* Honeycomb for spam protection */}
                <input type="text" name="_honey" style={{ display: 'none' }} />

                {/* Disable Captcha */}
                <input type="hidden" name="_captcha" value="false" />

                {/* Success Page Override (Optional - currently stays on page or redirects to FormSubmit success) */}
                <input type="hidden" name="_next" value="https://getsoruly.com/developer" />

                <input type="hidden" name="_subject" value="Yeni İletişim Formu Mesajı!" />
                <input type="hidden" name="_template" value="table" />

                <div className="form-group">
                    <label htmlFor="name">AD SOYAD</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        placeholder=""
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">E-POSTA ADRESİ</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder=""
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="subject">KONU</label>
                    <input
                        type="text"
                        id="subject"
                        name="subject"
                        required
                        placeholder=""
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="message">MESAJINIZ</label>
                    <textarea
                        id="message"
                        name="message"
                        required
                        rows="5"
                        placeholder=""
                    ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                    Mesaj Gönder <FaPaperPlane className="btn-icon" />
                </button>
            </form>
        </motion.div>
    );
};

export default ContactForm;
